import accordion from './utils/accordion.js';
import unit from './utils/unit.js';
import modalVideo from './utils/modalVideo.js';
import MicroModal  from './components/MicroModal.js';
import sliders   from './utils/sliders.js';
import Theme from './components/Theme.js';
import menu      from './utils/menu.js';
import cookies from './utils/cookies.js';
import Anim       from './components/Anim.js';
import lightGallery from 'lightgallery';
import Tabs      from './components/Tabs.js';
import DropPanel from './components/DropPanel.js';

function modalDefault() {
    MicroModal.init({
        openTrigger         : 'data-modal-open',
        closeTrigger        : 'data-modal-close',
        openClass           : 'is-open',
        disableScroll       : true,
        disableFocus        : false,
        awaitOpenAnimation  : true,
        awaitCloseAnimation : true,
        debugMode           : false,
    });
}

// Init
function init() {
    unit();
    accordion();
    modalVideo();
    modalDefault();
    sliders();
    Theme();
    menu();
    cookies();
    Anim();

    //Gallery of certificate
    lightGallery(document.getElementById("gallery-container"), {
        speed: 500,
    });

    // Tabs
    const tabContainer = document.querySelectorAll('[data-tab="tabs"]');
    tabContainer.forEach((tabContainer) => new Tabs(tabContainer));

    new DropPanel();

}

(function () {
	init();
}());
